import { Component, OnInit } from '@angular/core';

import { PurchaseStateService } from './../../../shared/services/purchase-state.service';
import { AuthService } from './../../../../auth/auth.service';
import { IPurchase } from '../../../shared/models/purchase';

@Component({
  selector: 'app-paynow-confirmation',
  templateUrl: './paynow-confirmation.component.html'
})
export class PayNowConfirmationComponent implements OnInit {
  isExamPurchase: boolean;
  examInfo = {
    isExamPurchase: false,
    schedulingLink: '',
    eligibilityEndDate: ''
  };
  ccpInfo = {
    isCcpPurchase: false,
    isAuditRequired: false,
    isAEC: false,
    requiredByDate: new Date()
  };  
  purchase: IPurchase;

  constructor(private purchaseState: PurchaseStateService,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.purchase = this.purchaseState.getCompletedPurchase();      
    
  }

  get paymentMethodLabel(): string {
    if (this.purchase.paymentMethod === 'V') {
      return 'Voucher';
    }
    if (this.purchase.paymentMethod === 'CP') {
      return 'No Payment Required';
    }
    if (this.purchase.paymentMethod === 'CH') {
       return 'Check';
    }
    if (this.purchase.paymentMethod === 'CC') {
      return 'Credit Card';
    }
    if (this.purchase.paymentMethod === 'ACH') {
      return 'E-Check';
    }
    return this.purchase.paymentMethod;
  }

  isNoMoneyDue(): boolean {
    if (this.purchase.total === 0)
      {return true;}
    else
      {return false;}
  }
}
